import React from 'react'

import { Banner, Button, ButtonClean, Icon, Subsection } from '@fourthwall/components'
import { SpotifyIcon } from '@fourthwall/icons'
import { routing } from '@utils/routing'

import * as S from './NoPostsFields.styled'

export const NoPostsFields = () => (
  <Subsection title="Add members-only audio to this podcast">
    <S.Container>
      <div>
        Allow members to listen to your audio posts on Spotify.{' '}
        <ButtonClean
          label="Learn more"
          withUnderline
          href="https://help.fourthwall.com/hc/en-us/articles/31440397820059-How-to-Share-Members-Only-Audio-Content-on-Spotify"
          target="_blank"
        />
      </div>
      <Banner
        appearance="warning"
        title={
          <>
            You don’t have any audio posts created yet.{' '}
            <ButtonClean
              label="Create a new post"
              to={`${routing.memberships.posts.create}?type=Audio`}
            />
          </>
        }
      />
      <Button
        appearance="secondary"
        leftIcon={<Icon component={SpotifyIcon} height={20} />}
        iconColor="#1ed760"
        label="Sync podcast to Spotify"
        disabled
      />
    </S.Container>
  </Subsection>
)
